function Footer() {
  return (
    <footer>
      &copy; {new Date().getFullYear()}. All rights reserved.
    </footer>
  );
}

export default Footer;
